import { getGetApiTenantsTenantSlugFeaturesQueryKey, useGetApiTenantsTenantSlugFeatures, type FeatureKey } from '@cdf/api-client-react';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { EntityFeaturesContext } from '@/features/tenancy/entity-features-context';

import { tenantSlugFromPath } from '@/features/tenancy/urls';
import { featureAvailable } from '@/features/tenancy/feature-ui';

/** Generated query key is scoped by entity slug inside the account/entity cache boundary. */
function useResolvedEntityFeatures(enabled: boolean) {
  const { pathname } = useLocation();
  const tenantSlug = tenantSlugFromPath(pathname);
  const query = useGetApiTenantsTenantSlugFeatures(tenantSlug ?? '', {
    query: { queryKey: getGetApiTenantsTenantSlugFeaturesQueryKey(tenantSlug ?? ''), enabled: enabled && Boolean(tenantSlug), staleTime: 0 }
  });
  return {
    tenantSlug,
    ...query,
    isEnabled: (key: FeatureKey) => ((key !== 'visitors' && key !== 'teams_and_colleagues') ||
      (!query.isPending && !query.isError && !query.isFetching && !query.isPlaceholderData)) &&
      featureAvailable(query.data?.items, key)
  };
}

export function useEntityFeatures(): ReturnType<typeof useResolvedEntityFeatures> {
  const inherited = useContext(EntityFeaturesContext);
  const resolved = useResolvedEntityFeatures(!inherited);
  return inherited ?? resolved;
}
